"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../palette/colors"));
const muiFormLabel = {
    styleOverrides: {
        root: {
            '&.Mui-focused': {
                color: colors_1.default.violet,
            },
        },
    },
};
exports.default = muiFormLabel;
//# sourceMappingURL=muiFormLabel.js.map